import { cva } from 'class-variance-authority';
import type { ToggleButtonGroupColors, ToggleButtonGroupSizes } from './types';

export const getRootClassName = cva('', {
  variants: {
    color: {
      neutral: 'bg-utility-gray-50',
      brand: 'bg-primary',
    } satisfies Record<ToggleButtonGroupColors, string>,
  },
});

export const getButtonGroupClassName = cva('gap-xs border border-tertiary', {
  variants: {
    size: {
      xs: 'p-xxs rounded-sm',
      sm: 'p-xxs rounded-sm',
      md: 'p-xs rounded-md shadow-xs',
      lg: 'p-xs rounded-3xl shadow-xs',
    } satisfies Record<ToggleButtonGroupSizes, string>,
  },
});
